module.exports = __webpack_public_path__ + "img/selection-icon-down__hover.6b5a25ea.svg";